export default __webpack_public_path__ + "static/cd-logo-dark-bg-37999a30ed94ea202ee8730657f7b8cd.svg";